import { EntityColumnOptions, entityColumn } from "components/UI/Table/columns/entity/entityColumn.tsx";
import { FILTER_TYPES } from "components/UI/Table/constants/filter.ts";
import { TableColumnType } from "components/UI/Table/types/table.ts";
import { EntityLinkCell } from "components/UI/Table/UI/EntityLinkCell/EntityLinkCell.tsx";

export const AdvertiserColumn = <T,>(options: EntityColumnOptions<T, App.Data.UserData>): TableColumnType<T> =>
    entityColumn<T, App.Data.UserData>(
        {
            dataIndex: "advertiser.nickname",
            key: "advertiser.nickname",
            sorter: true,
            filterable: true,
            filterType: FILTER_TYPES.advertiserSelect,
            filterName: "advertiser_id",
            sortName: "advertiser.nickname",
            ellipsis: true,
        },
        (entity) => <EntityLinkCell.Advertiser entity={entity} />,
        options
    );
